export class Image {
  private canvas: OffscreenCanvas;
  public readonly width: number;
  public readonly height: number;

  constructor(canvas: OffscreenCanvas) {
    this.canvas = canvas;
    this.width = canvas.width;
    this.height = canvas.height;
  }

  private get ctx() {
    const ctx = this.canvas.getContext('2d');

    if (!ctx) {
      throw new Error('Failed to get canvas 2D context');
    }

    return ctx;
  }

  static async fromImg(img: HTMLImageElement): Promise<Image> {
    await waitUntilElementLoaded(img);

    // 画像の実サイズ取得してcanvas内に描画
    const width = img.naturalWidth;
    const height = img.naturalHeight;

    const canvas = new OffscreenCanvas(width, height);

    const image = new this(canvas);

    image.ctx.drawImage(img, 0, 0, width, height);

    return image;
  }

  static async fromDataURL(dataURL: string): Promise<Image> {
    const img = new globalThis.Image();
    img.src = dataURL;
    return this.fromImg(img);
  }

  crop(crop: { unit: '%'; width: number; height: number; x: number; y: number }): Image {
    const width = Math.round((crop.width * this.canvas.width) / 100);
    const height = Math.round((crop.height * this.canvas.height) / 100);
    const x = Math.round((crop.x * this.canvas.width) / 100);
    const y = Math.round((crop.y * this.canvas.height) / 100);

    const prev = this.canvas;
    const next = new OffscreenCanvas(width, height);
    next.getContext('2d')?.drawImage(prev, x, y, width, height, 0, 0, width, height);

    return new Image(next);
  }

  resize(width: number, height: number): Image {
    const prev = this.canvas;
    const next = new OffscreenCanvas(width, height);
    next.getContext('2d')?.drawImage(prev, 0, 0, prev.width, prev.height, 0, 0, width, height);

    return new Image(next);
  }

  async toBlob(options: ImageEncodeOptions): Promise<Blob> {
    return this.canvas.convertToBlob(options);
  }
}

function waitUntilElementLoaded(el: HTMLElement): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    el.addEventListener('load', () => resolve(), { once: true });
    el.addEventListener('error', (e) => reject(e.error), { once: true });
  });
}
